import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemState,
} from 'react-accessible-accordion';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ResultsType } from '../../../../state/reducers/results.types';
import styles from './legal_basis_accordion.module.scss';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { HyperlinkRestrictedBaseModal } from '../../../../../components/HyperlinkRestrictedBaseModal';

type Legislation = NonNullable<ResultsType['snippets']['legalBasis']>[0];
type Articles = Legislation['articles'];

type Props = {
  articles: Articles;
  legislation: Legislation;
  isFirst: boolean;
  searchQueryUrl: string;
  eventName: string;
  source: string;
  ficheTitle: string;
};

export class LegalBasisSnippetAccordion extends React.Component<Props> {
  static defaultProps = {
    searchQueryUrl: '',
    onTopicPage: false,
    ficheTitle: '',
  };

  reportClick = (expanded: boolean | undefined, article: Articles[0]) => () => {
    const { legislation, eventName, source, ficheTitle } = this.props;
    doctrineAnalytics(eventName, {
      ...(ficheTitle ? { title: ficheTitle } : {}),
      source,
      reportOriginalQueryKey: true,
      article_id: article.docId,
      parent_text_short_title: legislation.mainTitle,
      title: article.title,
      expand_action: expanded ? 'close' : 'open',
      // parent_text_nature, // TODO data missing from service
    });
  };

  render() {
    const { articles, searchQueryUrl, isFirst, source } = this.props;
    const preExpandFistItemOfFirstAccordion = isFirst ? ['0'] : [];
    return (
      <Accordion
        allowZeroExpanded
        allowMultipleExpanded
        className={styles.container}
        preExpanded={preExpandFistItemOfFirstAccordion}
      >
        {articles.map((article, index) => (
          <AccordionItem
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            uuid={`${index}`}
            className={styles.itemContainer}
          >
            <AccordionItemHeading>
              <AccordionItemButton>
                <AccordionItemState>
                  {({ expanded }) => (
                    <div
                      className={styles.item}
                      onClick={this.reportClick(expanded, article)}
                    >
                      <span className={styles.label}>{article.title}</span>
                      <i
                        className={classNames(
                          'material-icons ',
                          styles.icon,
                          !expanded && 'icons__keyboard_arrow_down',
                          expanded && 'icons__keyboard_arrow_up',
                        )}
                      />
                    </div>
                  )}
                </AccordionItemState>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemState>
              {({ expanded }) => (
                <AnimateHeight
                  duration={200}
                  height={expanded ? 'auto' : 0}
                  easing={expanded ? 'ease-out' : 'ease-in'}
                >
                  <div className={styles.articleContainer}>
                    <p
                      className={styles.article}
                      dangerouslySetInnerHTML={{
                        __html: article.content || article.contentHtml || '',
                      }}
                    />
                    <HyperlinkRestrictedBaseModal
                      source={source}
                      url={`${article.url}?${searchQueryUrl}`}
                      className={styles.link}
                    >
                      <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippetAccordion.tsx/1" />
                    </HyperlinkRestrictedBaseModal>
                  </div>
                </AnimateHeight>
              )}
            </AccordionItemState>
          </AccordionItem>
        ))}
      </Accordion>
    );
  }
}
